const logoTp = "/logo.ico";
const logoTpWhite = "/logo-white.ico";
const meta = {
    title: "Terrasol 83",
    description: "Entreprise de terrassement, assainissement, dépannage et VRD basée dans le Var, nous intervenons pour tous vos travaux d'aménagement extérieur. Devis gratuit.",
};

const introdata = {
    title: "Terrasol 83",
    animated: {
        first: "Assainissement",
        second: "Terrassement",
        third: "VRD",
        fourth: "Aménagement extérieur",
        fifth: "Dépannage 24h/24, 7j/7"
    },
    description: "Terra<span class='desc-color'>sol</span>, c'est de l'<span class='desc-color'>Assainissement</span>, du <span class='desc-color'>Terrassement</span>, des <span class='desc-color'>VRD</span> et de l'<span class='desc-color'>Aménagement Extérieur</span> dans le Var.<br><br> ",
    description2: "Chaque terrain a ses contraintes et chaque projet ses besoins. Je prends le temps de les comprendre pour proposer une réalisation adaptée, propre et durable.",
    description3: "Que vous construisiez, rénoviez ou souhaitiez simplement aménager votre terrain, je vous accompagne directement sur votre projet, de la préparation jusqu'à la réalisation.", 
    description4: "Terra<span class='desc-color'>sol</span> assure également des <span class='desc-color'>interventions de dépannage et d'urgence assainissement 24h/24 et 7j/7</span>, pour répondre rapidement aux situations qui ne peuvent pas attendre.",
    description5: "Vous avez un projet ou besoin d'une intervention ? Parlons-en",
    description6: "- Kevin.", 
    your_img_url: "Profil-portfolio.webp",
};

const dataabout = {
    title: "A propos de moi",
    aboutme: `
        a modifier
        `,
};

const services = [{
    
        title: "Assainissement",
        description: "L'assainissement est au cœur de notre savoir-faire. Nous réalisons vos installations d'assainissement individuel et vos travaux de raccordement au réseau collectif, dans le respect des normes en vigueur. Fosse toutes eaux, micro-station, épandage, raccordement au tout-à-l'égout, évacuation des eaux usées et gestion des eaux pluviales : nous vous proposons des solutions adaptées à votre terrain, à votre habitation et à vos besoins. Notre priorité : une installation fiable, durable et correctement réalisée, de l'étude du projet jusqu'à sa mise en œuvre.",
    },

    {
        title: "Terrassement",
        description: "Vous avez un projet de construction, de rénovation ou d'aménagement extérieur ? Terrasol vous accompagne dans tous vos travaux de terrassement, de la préparation du terrain jusqu'aux finitions. Nivellement, décaissement, fouilles, création de plateformes ou préparation des fondations : nous intervenons avec du matériel adapté pour réaliser un travail précis, propre et durable. Chaque terrain étant différent, nous adaptons nos méthodes à votre projet et aux contraintes de votre environnement.",
    },

    {
        title: "VRD - Voirie et Réseaux Divers",
        description: "Terrasol réalise également vos travaux de VRD pour préparer et viabiliser votre terrain. Nous assurons la création des tranchées et la mise en place des différents réseaux : eau potable, électricité, télécommunications, évacuation des eaux usées et eaux pluviales. Nous réalisons également les accès, chemins, plateformes et autres aménagements nécessaires pour rendre votre terrain fonctionnel, accessible et prêt à accueillir votre projet.",
    },

    {
        title: "Aménagement extérieur et paysager",
        description: "Dans le Sud, on profite de son extérieur une grande partie de l'année : autant en faire un véritable lieu de vie ! Terrasol vous accompagne dans la création et l'aménagement de vos espaces extérieurs pour les rendre aussi beaux que fonctionnels. Création de jardins, mise en forme et préparation des terrains, allées, terrasses, espaces paysagers ou encore terrains de pétanque, nous réalisons des aménagements adaptés à vos envies et à votre environnement. Notre objectif : transformer votre extérieur en un espace agréable, convivial et durable, où vous aurez plaisir à passer du temps.",
    },

    {
        title: "Dépannage et intervention 24h/24",
        description: "Un problème d'assainissement, une canalisation bouchée ou une urgence liée à vos réseaux ? Terrasol intervient 24h/24 et 7j/7 pour vos dépannages. Nous nous déplaçons rapidement pour identifier l'origine du problème et mettre en œuvre une solution adaptée. Notre objectif est de limiter les dégâts et de vous permettre de retrouver rapidement une installation fonctionnelle et sécurisée.",
    },
];

const dataportfolio = [{
        img: "assainissement1.jpg", 
    },
    {
        img: "Terrassement1.jpg",
        // description: "Assainissement",
        // link: "https://kevinp83.github.io/", 
    },
    {
        img: "kasa.webp",
        // description: "VRD",
        // link: "https://github.com/kevinp83/kasa",
    },
    {
        img: "bluel.webp",
        // description: "Aménagement extérieur et paysager", 
        // link: "https://github.com/kevinp83/Sophie-Bluel-Kevin-P",
    },
];

const contactConfig = {
    YOUR_EMAIL: "contact@terrasol83.com",
    YOUR_FONE: "06.26.27.32.73",
    description: "Pour toute question n'hésitez pas à me contacter en remplissant le formulaire. Je répond sous 24h - 48h maximum.",
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    // linkedin: "https://www.linkedin.com/in/kevin-petoux-ba35481a7/",
};
export {
    meta,
    dataabout,
    dataportfolio,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logoTp,
    logoTpWhite,
};